import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import DatePicker from 'components/sales/datePicker/datePicker';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';
import 'assets/css/info-tooltip.css';
import axios from "services/interceptor/Interceptor";
import { ToastContainer, toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Config from "services/config/config";
import { FormGroup } from 'react-bootstrap';
import { UnifiedInvoiceModule } from './common';
import MilestoneInvoiceModule from 'components/sales/formSection/materialHardware/milestoneInvoiceModule';
import ModalPop from 'components/sales/modal/modal';
import { INVOICING_FREQUENCY, HARDWARE_TAGS_FREQUENCY, CONSUMABLES_FREQUENCY } from './constants/invoiceConstants';


const InvoiceModuleCapex = ({
  handleValue,
  totalAmount,
  gateData,
  prefilledData,
  handleInvoicePreview,
  capexInvoiceLink,
  solutionStages
}) => {
  var today = new Date();
  today.setDate(today.getDate() + 1);

  const [inputData, setInputData] = useState({
    hardware_amount: 0,
    tag_amount: 0,
    cartage_amount: 0,
    installation_amount: 0,
    total_amount: 0,
    invoice_count: 1,
    invoice_frequency_id: 1,
    invoice_nomenclature_id: 1,
    invoice_frequency_value: 'Single-Time',
    invoice_nomenclature_value: 'Solution-Level',
    invoice_consumable_boq_id: 1,
    invoice_consumable_boq_value: 'Solution-Level',
    advance_pi: 'yes',
    advance_pi_amount: 0,
    advance_pi_desc: '',
    convert_pi_ti: 'no',
    is_ra_bills: 'no',
    hardware_amount: 0,
    installation_amount: 0,
    cartage_amount: 0,
    tag_amount: 0,
    labour_amount: 0,
    consumable_amount: 0
  });
  const [isLoading, setIsLoading] = useState(false);
  const [capexAmount, setCapexAmount] = useState(0);
  const [totalHardwareAmount, setHardwareAmount] = useState(0);
  const [individualHardwareAmount, setIndividualHardwareAmount] = useState(0);
  const [individualSoftwareAmount, setIndividualSoftwareAmount] = useState(0);
  const [totalCartageAmount, setCartageAmount] = useState(0);
  const [totalInstallationAmount, setInstallationAmount] = useState(0);
  const [individualConsumableAmount, setIndividualConsumableAmount] = useState(0);
  const [individualLabourAmount, setIndividualLabourAmount] = useState(0);
  const [totalTagsAmount, setTagsAmount] = useState(0);
  const [isModal, setIsModal] = useState(false);
  const [isModalSuccess, setIsModalSuccess] = useState(false);
  const [solutionStagesData, setSolutionStagesData] = useState([]);
  const [lineData, setLineData] = useState({
    0: {
      0: {
        selected: [3030],
        description: '',
        amount: 0
      }
    }
  });
  const [inputRentention, setInputRentention] = useState([{
    description: '',
    amount: '',
    months: '',
    stage_id: '',
  }]);
  // Using constants from invoiceConstants.js
  const raBills = [
    {
      id: 'yes',
      name: "Yes",
    },
    {
      id: 'no',
      name: "No",
    }
  ];

  useEffect(() => {
    if (prefilledData !== '' || prefilledData !== undefined) {
      let solutionStagesRaw = [];
      if(solutionStages && solutionStages.stages && solutionStages.stages.length > 0){
        solutionStagesRaw = solutionStages.stages.map(stage => ({
          id: stage.id,
          name: stage.name
        }));
        setSolutionStagesData(solutionStagesRaw);
      }
      let onlyHardwareAmount = parseFloat((prefilledData?.commercial?.hardware_amount && prefilledData?.commercial?.hardware_amount !== undefined) ? prefilledData?.commercial?.hardware_amount : (totalAmount.hardware_amount ? totalAmount.hardware_amount : 0));
      let onlySoftwareAmount = parseFloat((prefilledData?.commercial?.software_amount && prefilledData?.commercial?.software_amount !== undefined) ? prefilledData?.commercial?.software_amount : (totalAmount.software_amount ? totalAmount.software_amount : 0));
      let hardwareAmount = onlyHardwareAmount + onlySoftwareAmount; 
      let labourAmount = parseFloat((prefilledData?.commercial?.labour_amount && prefilledData?.commercial?.labour_amount !== undefined) ? prefilledData?.commercial?.labour_amount : (totalAmount.labour_amount ? totalAmount.labour_amount : 0));
      let consumableAmount = parseFloat((prefilledData?.commercial?.consumable_amount && prefilledData?.commercial?.consumable_amount !== undefined) ? prefilledData?.commercial?.consumable_amount : (totalAmount.consumable_amount ? totalAmount.consumable_amount : 0));
      let installtionAmount = labourAmount + consumableAmount;
      let cartageAmount = parseFloat((prefilledData?.commercial?.cartage_amount && prefilledData?.commercial?.cartage_amount !== undefined) ? prefilledData?.commercial?.cartage_amount : (totalAmount.cartage_amount ? totalAmount.cartage_amount : 0));
      let tagAmount = parseFloat((prefilledData?.commercial?.tags_amount && prefilledData?.commercial?.tags_amount !== undefined) ? prefilledData?.commercial?.tags_amount : (totalAmount.tags_amount ? totalAmount.tags_amount : 0));
      let totalCapexAmount = (hardwareAmount + installtionAmount + cartageAmount + tagAmount).toFixed(2);
      setCapexAmount(totalCapexAmount);
      setHardwareAmount(hardwareAmount.toFixed(2));
      setIndividualHardwareAmount(onlyHardwareAmount.toFixed(2));
      setIndividualSoftwareAmount(onlySoftwareAmount.toFixed(2));
      setInstallationAmount(installtionAmount.toFixed(2));
      setIndividualConsumableAmount(consumableAmount.toFixed(2));
      setIndividualLabourAmount(labourAmount.toFixed(2));
      setCartageAmount(cartageAmount.toFixed(2));
      setTagsAmount(tagAmount.toFixed(2));
      if(prefilledData.capex_invoice_module){
        setInputData({
          ...inputData,
          hardware_amount: hardwareAmount.toFixed(2),
          installation_amount: installtionAmount.toFixed(2),
          cartage_amount: cartageAmount.toFixed(2),
          tag_amount: tagAmount.toFixed(2),
          total_amount: totalCapexAmount,
          labour_amount: labourAmount.toFixed(2),
          consumable_amount: consumableAmount.toFixed(2),
          invoice_frequency_id: prefilledData?.capex_invoice_module?.invoice_frequency_id,
          invoice_frequency_value: INVOICING_FREQUENCY.find(item => item.id === prefilledData?.capex_invoice_module?.invoice_frequency_id)?.name || '',
          invoice_nomenclature_id: prefilledData?.capex_invoice_module?.invoice_nomenclature_id,
          invoice_nomenclature_value: HARDWARE_TAGS_FREQUENCY.find(item => item.id === prefilledData?.capex_invoice_module?.invoice_nomenclature_id)?.name || '',
          invoice_consumable_boq_id: prefilledData?.capex_invoice_module?.invoice_consumable_boq_id,
          invoice_consumable_boq_value: CONSUMABLES_FREQUENCY.find(item => item.id === prefilledData?.capex_invoice_module?.invoice_consumable_boq_id)?.name,
          advance_pi: prefilledData?.capex_invoice_module?.advance_pi,
          advance_pi_amount: prefilledData?.capex_invoice_module?.advance_pi_amount,
          advance_pi_desc: prefilledData?.capex_invoice_module?.advance_pi_desc,
          convert_pi_ti: prefilledData?.capex_invoice_module?.convert_pi_ti,
          invoice_count: prefilledData?.capex_invoice_module?.invoice_count,
          is_ra_bills: prefilledData?.capex_invoice_module?.is_ra_bills
        });
        const rawInvoiceItems =
          prefilledData?.capex_invoice_module?.invoices_items || {};
        let parsedInvoiceItems = rawInvoiceItems;
        if (typeof rawInvoiceItems === 'string') {
          try {
            parsedInvoiceItems = JSON.parse(rawInvoiceItems);
          } catch (error) {
            parsedInvoiceItems = {};
          }
        }
        const nextLineData = JSON.parse(JSON.stringify(parsedInvoiceItems));
        let retentionData = [];
        if(prefilledData?.milestone?.retention && prefilledData?.milestone?.retention.length > 0){
          retentionData = prefilledData?.milestone?.retention?.map((data) => {
            const matchedStage = solutionStagesRaw.find(stage => stage.id === data.post_stage_value);
          
            return {
              ...data,
              amount: data.percentage,
              description: data.desc,
              stage_id: data.post_stage_value,
              post_stage_value: matchedStage ? matchedStage.name : '',
            };
          });
        }
        setLineData(nextLineData);
        if (retentionData.length > 0) setInputRentention(retentionData);
      }else{
        setInputData({
          ...inputData,
          hardware_amount: hardwareAmount.toFixed(2),
          installation_amount: installtionAmount.toFixed(2),
          cartage_amount: cartageAmount.toFixed(2),
          tag_amount: tagAmount.toFixed(2),
          total_amount: totalCapexAmount,
          labour_amount: labourAmount.toFixed(2),
          consumable_amount: consumableAmount.toFixed(2)
        });
      }
    }
  }, [prefilledData, totalAmount]);

  useEffect(() => {
    if (capexInvoiceLink && capexInvoiceLink.length > 0 && capexInvoiceLink[0]) {
      setIsModalSuccess(true)
      setIsModal(true);
    }
  }, [capexInvoiceLink])

  const handleResetLineItems = (label) => {
    setLineData({
      0: {
        0: {
          selected: [label],
          description: '',
          amount: 0
        }
      }
    });
  }

  const getFirstEnabledRowIndex = (invoiceData, disabledRows = []) => {
    return Object.keys(invoiceData)
      .map(k => parseInt(k))
      .sort((a, b) => a - b)
      .find(index => !disabledRows.includes(index));
  };

  const handleCheckboxChange = (
    invoiceIndex,
    rowIndex,
    label,
    labelName,
    checked,
    autoClean = true,
    overwrite = false
  ) => {
    setLineData(prev => {
      const currentInvoiceData = prev[invoiceIndex] || {};
      const currentRow = currentInvoiceData[rowIndex] || { selected: [], description: '', amount: 0 };
  
      // Update selected items
      let newSelected = checked
        ? overwrite
          ? [label]
          : currentRow.selected.includes(label)
            ? currentRow.selected
            : [...currentRow.selected, label]
        : currentRow.selected.filter(item => item !== label);
  
      // ✅ Reset description and amount if no checkboxes are selected
      const shouldClear = newSelected.length === 0;
  
      const updatedRow = {
        ...currentRow,
        selected: newSelected,
        description: shouldClear ? '' : currentRow.description,
        amount: shouldClear ? 0 : currentRow.amount
      };
  
      const updatedInvoiceData = { ...currentInvoiceData, [rowIndex]: updatedRow };
  
      // Clean up empty rows
      const cleanedInvoiceData = {};
      for (const [key, row] of Object.entries(updatedInvoiceData)) {
        const isEmpty =
          (row.selected?.length || 0) === 0 &&
          (row.description?.trim?.() || '') === '' &&
          Number(row.amount) === 0;
  
        if (!(autoClean && isEmpty)) {
          cleanedInvoiceData[key] = row;
        }
      }
  
      // Final clean up: remove invoice if empty
      const newLineData = { ...prev };
      if (Object.keys(cleanedInvoiceData).length > 0) {
        newLineData[invoiceIndex] = cleanedInvoiceData;
      } else {
        delete newLineData[invoiceIndex];
      }
  
      return newLineData;
    });
  };
  


  const isCheckboxDisabled = (labelId, invoiceIndex, rowIndex) => {
    return Object.entries(lineData).some(([invIdx, lines]) =>
      Object.entries(lines).some(([lineIdx, data]) =>
        data.selected?.includes(labelId) &&
        !(+invIdx === invoiceIndex && +lineIdx === rowIndex)
      )
    );
  };

  const handleDescriptionChange = (invoiceIndex, rowIndex, newDescription) => {
    setLineData(prev => {
      const currentInvoiceData = prev[invoiceIndex] || {};
      const currentRow = currentInvoiceData[rowIndex] || { selected: [], description: '', amount: 0 };

      return {
        ...prev,
        [invoiceIndex]: {
          ...currentInvoiceData,
          [rowIndex]: {
            ...currentRow,
            description: newDescription,
          }
        }
      };
    });
  };

  const handleAmountChange = (invoiceIndex, rowIndex, newAmount) => {
    setLineData(prev => {
      const currentInvoiceData = prev[invoiceIndex] || {};
      const currentRow = currentInvoiceData[rowIndex] || { selected: [], description: '', amount: 0 };

      return {
        ...prev,
        [invoiceIndex]: {
          ...currentInvoiceData,
          [rowIndex]: {
            ...currentRow,
            amount: newAmount,
          }
        }
      };
    });
  };

  useEffect(() => {
    handleValue({ invoice_module: inputData, line_items: lineData, retention: inputRentention });
  }, [inputData, lineData, inputRentention]);

  const handleSuccessModalHide = () => {
    setIsModalSuccess(false);
  }

  const handleModalHide = () => setIsModal(false);

  return (
    
    <Fragment>
      <FormSection isLoading={isLoading}>
        <>
          <div className='row'>
            <div className='col-md-12' style={{ marginBottom: '10px' }}>
              <span><b>Contract Amount :</b> &nbsp;₹&nbsp;
                {capexAmount}
              </span>
            </div>
          </div>

          <div className='row' style={{ marginBottom: '10px' }}>
            <div className='col-md-3'>
              <span>
                <b>Hardware Amount :</b> &nbsp;₹&nbsp;
                {totalHardwareAmount}
                &nbsp;
                <span className="info-icon-container">
                  <span className="info-icon">i</span>
                  <div className="info-tooltip">
                    <div className="tooltip-title">Breakdown:</div>
                    <div className="tooltip-item">Hardware: ₹{individualHardwareAmount}</div>
                    <div className="tooltip-item">Software: ₹{individualSoftwareAmount}</div>
                  </div>
                </span>
              </span>
            </div>
            <div className='col-md-3'>
              <span>
                <b>Installation Amount :</b> &nbsp;₹&nbsp;
                {totalInstallationAmount}
                &nbsp;
                <span className="info-icon-container">
                  <span className="info-icon">i</span>
                  <div className="info-tooltip">
                    <div className="tooltip-title">Breakdown:</div>
                    <div className="tooltip-item">Labour: ₹{individualLabourAmount}</div>
                    <div className="tooltip-item">Consumables: ₹{individualConsumableAmount}</div>
                  </div>
                </span>
              </span>
            </div>
            <div className='col-md-3'>
              <span><b>Cartage Amount :</b> &nbsp;₹&nbsp;
                {totalCartageAmount}
              </span>
            </div>
            <div className='col-md-3'>
              <span><b>Tags Amount :</b> &nbsp;₹&nbsp;
                {totalTagsAmount}
              </span>
            </div>
          </div>

          <div className='row'>
            <div className='col-md-12'>
              <hr />
            </div>
          </div>

          <div className='row'>
            <div className='col-md-4'>
              <div className="flex form-group">
                <label htmlFor="invoicing-frequency" className="whitespace-nowrap font-medium">
                  Invoicing Frequency?
                </label>
                <select
                  id="invoicing-frequency"
                  className="border border-gray-300 rounded px-3 py-2 w-full max-w-sm form-control"
                  value={inputData.invoice_frequency_value}
                  onChange={(e) => {
                    const selected = INVOICING_FREQUENCY.find(opt => opt.name === e.target.value);
                    const id = selected?.id || '';
                    const invoicingFreq = parseInt(id);
                    if (invoicingFreq !== parseInt(inputData?.invoice_frequency_id)) {
                      const confirmReset = window.confirm("Changing Invoicing Frequency will reset your existing data. Are you sure?");
                      if (confirmReset) {
                        setInputData({
                          ...inputData,
                          invoice_frequency_id: id,
                          invoice_frequency_value: e.target.value,
                          invoice_nomenclature_id: id === 1 ? 1 : '',
                          invoice_nomenclature_value: id === 1 ? 'Solution-Level' : '',
                          invoice_consumable_boq_id: id === 1 ? inputData.invoice_consumable_boq_id : '',
                          invoice_consumable_boq_value: id === 1 ? inputData.invoice_consumable_boq_value : '',
                          advance_pi: id === 1 ? inputData.advance_pi : 'no',
                          advance_pi_amount: id === 1 ? inputData.advance_pi_amount : 0,
                          advance_pi_desc: id === 1 ? inputData.advance_pi_desc : '',
                          convert_pi_ti: id === 2 ? 'yes' : 'no',
                          invoice_count: 1
                        });
                        handleResetLineItems((id === 1 ? 3030 : 3051));
                      }
                    }
                  }}
                  required
                >
                  <option value="" disabled>Select an option</option>
                  {INVOICING_FREQUENCY.map((option) => (
                    <option key={option.id} value={option.name}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className='col-md-2'>
            </div>
            <div className='col-md-6' style={{ display: (inputData.invoice_frequency_id == 1 ? "block" : 'none') }}>
              <div className="flex form-group">
                <label htmlFor="hardwareTags-frequency" className="whitespace-nowrap font-medium">
                  Hardware/Tags Invoice Nomenclature?
                </label>
                <select
                  id="hardwareTags-frequency"
                  className="border border-gray-300 rounded px-3 py-2 w-full max-w-sm form-control"
                  value={inputData.invoice_nomenclature_value}
                  onChange={(e) => {
                    const selected = HARDWARE_TAGS_FREQUENCY.find(opt => opt.name === e.target.value);
                    const id = selected?.id || '';
                    const hardwareFreq = parseInt(id);
                    if (hardwareFreq !== parseInt(inputData?.invoice_nomenclature_id)) {
                      const confirmReset = window.confirm("Changing Hardware/Tags Nomenclature will reset your existing data. Are you sure?");
                      if (confirmReset) {
                        setInputData({
                          ...inputData,
                          invoice_nomenclature_id: id,
                          invoice_nomenclature_value: e.target.value,
                          invoice_consumable_boq_id: (inputData.invoice_frequency_id == 1 && id == 2 ? 1 : ''),
                          invoice_consumable_boq_value: (inputData.invoice_frequency_id == 1 && id == 2 ? 'Solution-Level' : ''),
                          invoice_count: 1
                        });
                        handleResetLineItems(3030);
                      }
                    }
                  }}
                  required
                  disabled={inputData.invoice_frequency_id == 1 ? false : true}
                >
                  <option value="" disabled>Select an option</option>
                  {HARDWARE_TAGS_FREQUENCY.map((option) => (
                    <option key={option.id} value={option.name}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
          {
            (inputData.invoice_frequency_id === 1 && inputData.invoice_nomenclature_id === 1) &&
            <UnifiedInvoiceModule
              setInputData={setInputData}
              inputData={inputData}
              handleCheckboxChange={handleCheckboxChange}
              handleDescriptionChange={handleDescriptionChange}
              lineData={lineData}
              isCheckboxDisabled={isCheckboxDisabled}
              handleResetLineItems={handleResetLineItems}
              handleInvoicePreview={handleInvoicePreview}
              moduleType="single"
            />
          }
          {
            (
              (inputData.invoice_frequency_id === 1 && inputData.invoice_nomenclature_id === 2 && inputData.invoice_consumable_boq_id === 1 ) && 
              <UnifiedInvoiceModule
                setInputData={setInputData}
                inputData={inputData}
                handleCheckboxChange={handleCheckboxChange}
                handleDescriptionChange={handleDescriptionChange}
                lineData={lineData}
                handleResetLineItems={handleResetLineItems}
                isCheckboxDisabled={isCheckboxDisabled}
                handleInvoicePreview={handleInvoicePreview}
                moduleType="solution"
              />
            )
          }
          {
            (
              (inputData.invoice_frequency_id === 1 && inputData.invoice_nomenclature_id === 2 && inputData.invoice_consumable_boq_id === 2 ) && 
              <UnifiedInvoiceModule
                setInputData={setInputData}
                inputData={inputData}
                handleCheckboxChange={handleCheckboxChange}
                handleDescriptionChange={handleDescriptionChange}
                lineData={lineData}
                handleResetLineItems={handleResetLineItems}
                isCheckboxDisabled={isCheckboxDisabled}
                handleInvoicePreview={handleInvoicePreview}
                moduleType="consumable"
              />
            )
          }
          {
            (
              (inputData.invoice_frequency_id === 2) &&
              <MilestoneInvoiceModule
                setInputData={setInputData}
                inputData={inputData}
                handleCheckboxChange={handleCheckboxChange}
                handleDescriptionChange={handleDescriptionChange}
                lineData={lineData}
                handleAmountChange={handleAmountChange}
                isCheckboxDisabled={isCheckboxDisabled}
                raBills={raBills}
                solutionStages={solutionStagesData}
                inputRentention={inputRentention}
                setInputRentention={setInputRentention}
              />
            )
          }
        </>
      </FormSection>
      <ModalPop
        title={'Invoices Preview'}
        show={isModalSuccess}
        handleModalHide={handleSuccessModalHide}
        keyboard
        backdrop
      >
        <>
          <div className="pdf-preview-container">
            {capexInvoiceLink.map((invoiceLink, index) => (
              <iframe
                key={index}
                src={`${invoiceLink}#toolbar=0`}
                title={`Invoice PDF ${index + 1}`}
                width="100%"
                height="700px"
                style={{ border: "none", marginBottom: "1rem" }}
              />
            ))}
          </div>
        </>
      </ModalPop>
    </Fragment>
  );
};

InvoiceModuleCapex.propTypes = {
  handleValue: PropTypes.func,
};

export default InvoiceModuleCapex;
